/**
* Quote With Animation JS
* -----------------------------------------------------------------------------
*
* All the JS for the Quote With Animation component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'quote-with-animation',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.quote-with-animation' ).each( function( key, component ) {
        const image = $( this ).find( '.image-wrapper' )[0];
        let navHeight = $( '.navbar' ).height();
        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).height();
        }

        lottieScrollTrigger( {
          target: $( component ).find( '.lottie-animation' ),
          path: $( component ).find( '.lottie-animation' ).attr( 'data-url' ),
          speed: 'medium',
          start: 'top ' + navHeight,
          end: '+=150%',
          pin: component,
          pinSpacing: true,
          markers: false,
          scrub: 1,
        } );

        function lottieScrollTrigger( vars ) {
          console.log( vars.path );
          const playhead = {frame: 0};
          const target = gsap.utils.toArray( vars.target )[0];
          const speeds = {slow: '+=2000', medium: '+=1000', fast: '+=500'};
          const st = {
            trigger: component,
            pin: vars.pin,
            pinSpacing: vars.pinSpacing,
            start: vars.start,
            end: vars.end,
            markers: vars.markers,
            scrub: vars.scrub,
          };

          const animation = lottie.loadAnimation( {
            container: target,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: vars.path,
          } );

          animation.addEventListener( 'DOMLoaded', function() {
            gsap.to( playhead, {
              frame: animation.totalFrames - 1,
              ease: 'none',
              onUpdate: () => animation.goToAndStop( playhead.frame, true ),
              scrollTrigger: st,
            } );
            ScrollTrigger.sort();
            ScrollTrigger.refresh();
          } );
          return animation;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'quote-with-animation', COMPONENT );
} )( app );
